import clsx from "classnames";
import PropTypes from "prop-types";
import classes from "./styles.module.scss";
import { trimText } from "@/functions/trimText";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";

export const ArticleCard = ({ className, title, type, description, variant, image, href }) => {
  return (
    <a href={href} className={clsx(className, classes.card, `variant-${variant}`)}>
      <SourceFlowImage className={clsx(classes.card__img)} size="422x" src={image} alt={`${title} cover image`} />
      <div className={clsx(classes.card__tag, "p-4")}>
        {type !== "Case Studies" && <span>{type === "Blogs" ? `Blog` : type}</span>}
      </div>
      <div className={clsx(classes.card__details, "p-4")}>
        <h3 className="h6">{title}</h3>
        <div className={clsx(classes.card__description)} dangerouslySetInnerHTML={{ __html: trimText(description) }} />
        <div className={clsx(classes.card__footer, "pt-4")}>
          <span>Read More</span>
        </div>
      </div>
    </a>
  );
};

ArticleCard.defaultProps = {
  variant: "default",
};

ArticleCard.propTypes = {
  variant: PropTypes.oneOf(["default", "wide", "tall", "feed"]),
};
